import React from "react";
import LargeHeaderTitle from "../LargeHeaderTitle";

const BookDemoHeroTitle = ({
  title = "Transform Your Trading Journey with ",
  highlight = "Automated Excellence",
}) => (
  <LargeHeaderTitle title={title} highlight={highlight} />
);

export default BookDemoHeroTitle; 